<template>
  <v-app>
    <v-app-bar height="110" dark app hide-on-scroll>
      <v-app-bar-nav-icon v-if="drawer" @click="mostrar = !mostrar"></v-app-bar-nav-icon>
      <v-btn to="/" value min-width="300" min-height="100" depressed active-class="false">
        <v-img src="../public/img/portada 1.png" aspect-ratio="3" contain></v-img>
      </v-btn>
      <v-spacer></v-spacer>
      <div v-if="!drawer">
        <v-btn :to="{name: boton.link }" depressed v-for="(boton, i) in componentes" :key="i">
          <span>{{ boton.label }}</span>
        </v-btn>
      </div>
    </v-app-bar>
    <v-navigation-drawer v-if="drawer" v-model="mostrar" app dark>
      <v-list nav dense>
        <v-list-item-group>
          <v-list-item
            :to="{name: componente.link }"
            v-for="(componente, i) in componentes"
            :key="i"
          >
            <v-list-item-title>{{ componente.label }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-content>
      <router-view></router-view>
    </v-content>
    <v-footer dark>
      <v-row dense>
        <v-col cols="12" md="4" sm="12" xs="12" align="center">
          <p
            class="text-sm-center text-xs-center text-md-left"
          >Copyrigth © Wallaudit - Todos los derechos reservados</p>
        </v-col>
        <v-col cols="12" md="4" sm="12" xs="12" align="center">
          <v-row no-gutters>
            <v-col v-for="(red, i) in redesSociales" :key="i">
              <a :href="red.link" target="_blank">
                <v-img :src="red.imgUrl" height="30px" width="30px"></v-img>
              </a>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="4" sm="12" xs="12" align="center">
          <p class="text-sm-center text-xs-center text-md-right">By Wallaudit</p>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "App",
  created() {
    this.$vuetify.theme.dark = true;
  },
  computed: {
    drawer() {
      var regreso = false;
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          regreso = true;
          break;
        case "sm":
          regreso = true;
          break;
        case "md":
          regreso = false;
          break;
        case "lg":
          regreso = false;
          break;
        case "xl":
          regreso = false;
          break;
      }

      return regreso;
    }
  },
  components: {},

  data() {
    return {
      mostrar: false,
      componentes: [
        { label: "Nosotros", link: "nosotros" },
        { label: "Servicios", link: "servicios" },
        // { label: 'Reservar', link: 'reservar'},
        //{ label: "Blog", link: "blog" },
        { label: "Contacto", link: "contacto" }
      ],
      redesSociales: [
        {
          imgUrl: require("../public/img/facebook.png"),
          link: "https://www.facebook.com/wallaudit"
        }
        // {
        //   imgUrl: require('../public/img/instagram.png'),
        //   link: 'https://instagram.com/sunsetravelpv'
        // },
        // {
        //   imgUrl: require('../public/img/twitter.png'),
        //   link: 'https://twitter.com/sunsetravelpv'
        // },
      ]
      //
    };
  }
};
</script>
